import { IThoiGianHocLopHCActionTypes } from "../../action-types/category/IThoiGianHocLopHCActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThoiGianHocLopHCReducer } from "../../reducer-model/category/IThoiGianHocLopHCReducer";

const initState: IThoiGianHocLopHCReducer = {
  status: eReducerStatusBase.is_not_initialization,
  thoiGianHocLopHCs: [],
};
export const thoiGianHocLopHCReducer = (
  state: IThoiGianHocLopHCReducer = initState,
  action: IThoiGianHocLopHCActionTypes
): IThoiGianHocLopHCReducer => {
  switch (action.type) {
    case "THOI_GIAN_HOC_LOP_HC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "THOI_GIAN_HOC_LOP_HC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        thoiGianHocLopHCs: action.payload,
      };
    case "THOI_GIAN_HOC_LOP_HC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "THOI_GIAN_HOC_LOP_HC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        thoiGianHocLopHCEditing: action.payload,
      };
    case "THOI_GIAN_HOC_LOP_HC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "THOI_GIAN_HOC_LOP_HC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "THOI_GIAN_HOC_LOP_HC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "THOI_GIAN_HOC_LOP_HC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "THOI_GIAN_HOC_LOP_HC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "THOI_GIAN_HOC_LOP_HC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "THOI_GIAN_HOC_LOP_HC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
